import { isQuietMaintenanceFailure } from "./maintenance-retry";

// Failures of third-party scripts the app does not control. Each pattern matches only that script's own error.
export const sentryNoiseFilters = {
  beforeSend: <T>(event: T, hint: { originalException?: unknown }): T | null =>
    isQuietMaintenanceFailure(hint.originalException) ? null : event,
  ignoreErrors: [
    // The TikTok in-app browser injects a click tracker and an autofill script that log their own failures through
    // console.error, which captureConsoleIntegration reports (AWRAQ-2GK, AWRAQ-2K3, AWRAQ-2MS).
    /\bclassName\.slice is not a function\b/,
    /^\[AutofillPlugin\]/,
  ],
  denyUrls: [
    // Google's reCAPTCHA script keeps running timers after the sign-in page that loaded it unmounts (AWRAQ-2KX, AWRAQ-2M8).
    /^https:\/\/www\.(?:google|gstatic)\.com\/recaptcha\//,
    // A frame named after one of our pages instead of a script file ran inline in the page. The app ships no executable
    // inline script, so that code was injected by the browser, such as Chrome on iOS translating the page (AWRAQ-2H0).
    /^https:\/\/(?:[\w-]+\.)*awraq\.app\/(?![^?#]*\.m?js(?:[?#]|$))/,
  ],
};
